// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/operatingCertificate/OperatingCertificate.css
// module id = 1327
// module chunks = 0